import React, { useRef } from 'react';

import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PROVIDER_ID_FROM_P2P, PROVIDER_ID_TO_P2P } from 'apps/auth/constants/Constants';
import {
    AGENT_TO_LIBRE,
    CASH_WITHDRAWAL,
    CREDIT,
    DELIVERY,
    EXCHANGE,
    OFFLINE_PAYMENT,
    ONLINE_PAYMENT,
    REFUND,
    TOP_UP,
    TRANSFER_FROM_GT,
    UNKNOWN,
} from 'apps/auth/constants/GaConstants';

import ActivityCashDetails from './ActivityCashDetails';
import ActivityDeliveryDetails from './ActivityDeliveryDetails';
import ActivityExchangeDetails from './ActivityExchangeDetails';
import ActivityFasterPaymentDetails from './ActivityFasterPaymentDetails';
import ActivityGlobalTransferDetails from './ActivityGlobalTransferDetails';
import ActivityOnlineDetails from './ActivityOnlineDetails';
import ActivityP2PDetails from './ActivityP2PDetails';
import ActivityRefundDetails from './ActivityRefundDetails';
import CommonPaymentDetails from './CommonPaymentDetails';
import LibreHistoryFlow from './libre/LibreHistoryFlow';
import OfflinePaymentDetails from './OfflinePaymentDetails';
import TopUpDetails from './TopUpDetails';
import UnknownDetails from './UnknownDetails';
import ActivityMorePopup from '../popup/ActivityMorePopup';

const ActivityDetailsModal = (props) => {
    const popupRef = useRef(null);
    const icon = props.item.mobileInfo.icon;

    const getDetails = (item, pocketId, options) => {
        if (icon === EXCHANGE) {
            return <ActivityExchangeDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === OFFLINE_PAYMENT) {
            return <OfflinePaymentDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === TOP_UP) {
            return <TopUpDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === DELIVERY) {
            return <ActivityDeliveryDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === ONLINE_PAYMENT) {
            return <ActivityOnlineDetails pocketId={pocketId} item={item} options={options} />;
        } else if (TRANSFER_FROM_GT.includes(icon)) {
            if (item.mobileInfo.direction === CREDIT) {
                return <ActivityFasterPaymentDetails pocketId={pocketId} item={item} options={options} />;
            } else {
                return <ActivityGlobalTransferDetails pocketId={pocketId} item={item} options={options} />;
            }
        } else if (
            (item.frPrvId === PROVIDER_ID_FROM_P2P || item.frPrvId === PROVIDER_ID_TO_P2P) &&
            (item.toPrvId === PROVIDER_ID_FROM_P2P || item.toPrvId === PROVIDER_ID_TO_P2P)
        ) {
            return <ActivityP2PDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === UNKNOWN) {
            return <UnknownDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === CASH_WITHDRAWAL) {
            return <ActivityCashDetails pocketId={pocketId} item={item} options={options} />;
        } else if (icon === REFUND) {
            return <ActivityRefundDetails pocketId={pocketId} item={item} options={options} />;
        } else {
            return <CommonPaymentDetails pocketId={pocketId} item={item} options={options} />;
        }
    };

    const moreClickHandler = (e) => {
        e.preventDefault();
        popupRef.current?.open(<ActivityMorePopup item={props.item} popupRef={popupRef} />);
    };

    if (props.item.patternId === AGENT_TO_LIBRE) {
        return <LibreHistoryFlow pocketId={props.pocketId} item={props.item} options={props.options} moreClickHandler={moreClickHandler} />;
    }

    return (
        <>
            <ModalComponent onClickMoreIcon={moreClickHandler}>{getDetails(props.item, props.pocketId, props.options)}</ModalComponent>;
            <PopupNew ref={popupRef} />
        </>
    );
};

export default ActivityDetailsModal;
